import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import classNames from './styles.module.scss'


export default function PlayButton() {
  return <FontAwesomeIcon icon="far fa-play" transform="shrink-8 right-0.5" size="4x" mask="fas fa-circle" className={classNames.playBtn} />
}
